<template>
    <div class="hero">
<h1 class="page-header caveat">&nbsp;&nbsp;Log In</h1>
        <div id="main-hero" class="hero-body">
            <div class="container has-text-centered">
                <div class="columns">
                    <div class="column">
                        <div class="content pt-20">
                        <img
                                width="225"
                                src="../assets/images/logos/logo-m.png"
                                alt="My Meatloaf Logo"
                            >
                            <div class="is-size-4">                
                                Literally, Just the Recipe
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns pt-20 pb-20">
                    <div class="column is-6 is-offset-3 z-index-2">
                        <!-- Login form -->
                        <div id="login-card" class="animated preFadeInLeft fadeInLeft">
                            <div class="flex-card clean-login-card">
                                <!--<h2 class="text-bold title is-3">Login</h2>-->
                                <b-field label="Email"
                                label-position="inside">
                                    <b-input type="email"
                                        v-model="email">
                                    </b-input>
                                </b-field>
                                <b-field label="Password"
                                label-position="inside">
                                    <b-input v-model="password" type="password"></b-input>
                                </b-field>
                            <!--
                                <div class="field mt-20">
                                    <div class="control">
                                        <label class="checkbox-wrap is-medium">
                                                        <input id="check2" type="checkbox" class="d-checkbox">
                                                        <span></span>
                                                        Remember me
                                                    </label>
                                    </div>
                                </div>
                            -->
                                <div class="mt-20">
                                    <button @click="login" class="button button-cta btn-align secondary-btn is-fullwidth rounded raised no-lh">Login</button>
                                </div>
                            </div>
                            <p>
                                or Sign In with Google <br>
                                <button @click="socialLogin" class="social-button">
            <img alt="Google Logo" src="../assets/google-logo.png">
          </button>
                            </p>
                            <p class="has-text-centered pt-20 pb-20">
                            <router-link :to="{name: 'ResetPassword'}">  
                                Lost your password? 
                            </router-link>
                            </p>
                        </div>
                        <!-- /Login form -->
    
                        <!-- Recover form -->
                        <div id="recover-card" class="animated preFadeInLeft fadeInLeft is-hidden">
                            <div class="flex-card clean-login-card">
                                <h2 class="text-bold dark-text">Reset Password</h2>
                                <form>
                                    <div class="control-material is-secondary">
                                        <input class="material-input" type="text" required>
                                        <span class="material-highlight"></span>
                                        <span class="bar"></span>
                                        <label>Email address *</label>
                                    </div>
    
                                    <div class="mt-20">
                                        <button class="button button-cta btn-align secondary-btn rounded is-fullwidth raised no-lh">Reset Password</button>
                                    </div>
                                </form>
                            </div>
    
                            <p class="has-text-centered pt-20 pb-20">
                                <a id="show-login" class="no-account is-secondary" href="#">Back to login</a>
                            </p>
                        </div>
                        <!-- /Recover form -->
                    </div>
                </div>
            </div>
        </div>
        <!-- /Hero image -->
    </div>
</template>

<script>
import firebase from '@/firebase';
import db from '@/db';
export default {
    name: 'login',
    data() {
        return {
            email: '',
            password: ''
        }
    },
    mounted() {
        let user = firebase.auth().currentUser;
        if (user) {
            this.$router.replace('/');
        }
    },
    methods: {
        login() {
            firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(() => {

                this.$router.replace('/');
            }).catch((err) => {
                alert('Oops. ' + err.message)
            });
        },
        socialLogin() {
            const vm = this;
            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider).then((user) => {
                
                var docRef = db.collection("users").doc(user.user.uid);
                docRef.get().then(function(doc) {
                    if (doc.exists) {
                        vm.$router.replace('/account');
                    } else {
                         db.collection("users").doc(user.user.uid).set({
                                    id: user.user.uid,
                                    name: user.user.displayName,
                                    kitchen_name: user.user.displayName,
                                    image: null,
                                    created_at: new Date(),
                        }).then(()=>{
                            window.location='/account'
                        });
                        
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            }).catch((err) => {
                alert('Oops. ' + err.message)
            });
        }
    }
}
</script>

<style scoped>
  /* "scoped" attribute limit the CSS to this component only */

  .login {
      margin-top: 40px;
  }

  input {
      margin: 10px 0;
      width: 20%;
      padding: 15px;
  }

  button {
      margin-top: 20px;
      width: 10%;
      cursor: pointer;
  }

  p {
      margin-top: 40px;
      font-size: 13px;
  }

  p a {
      text-decoration: underline;
      cursor: pointer;
  }

  .social-button {
      width: 75px;
      background: white;
      padding: 10px;
      border-radius: 100%;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
      outline: 0;
      border: 0;
  }

  .social-button:active {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }

  .social-button img {
      width: 100%;
  }
</style>